
document.addEventListener("DOMContentLoaded", function (event) {
  $('.button-request').on('click', function (e) {
    let consentArray = {
      '$first_name': $('input#first_name').val(),
      '$last_name': $('input#last_name').val()
    };
    $('.checkbox-field input:checked').each(function () {
      let item = '' + $(this).val();
      consentArray[item] = 'Yes';
    });

    function klaviyoPrivacy() {
      let klaviyoPrivacy = $('#consent-klaviyo').val();
      let consentPrivacy = $('#consent-privacy').val();
      consentArray[klaviyoPrivacy] = consentPrivacy;
    }

    function klaviyoConsent() {
      var kvaviyoConsentName = $("#consent-title").val();
      var kvaviyoConsentValue = $("#consent-value").val();
      consentArray[kvaviyoConsentName] = kvaviyoConsentValue;
    }

    function klaviyoForm() {
      let kvaviyoFormName = $("#form-title").val();
      let kvaviyoFormValue = $("#form-value").val();
      consentArray[kvaviyoFormName] = kvaviyoFormValue;
    }

    function klaviyoEmailMarketing() {
      if ($('#consent_marketing').is(':checked')) {
        let kvaviyoAcceptsName = $("#accepts-title").val();
        let kvaviyoAcceptsValue = $("#accepts-value").val();
        consentArray[kvaviyoAcceptsName] = kvaviyoAcceptsValue;
      }
    }

    klaviyoPrivacy();
    klaviyoForm();
    klaviyoConsent();
    klaviyoEmailMarketing();
    function onIdentifyCompleteCallback() {
      _learnq.push(['identify', consentArray]);
      _learnq.push(['identify', klaviyoPrivacy()]);
      _learnq.push(['identify', klaviyoForm()]);
      _learnq.push(['identify', klaviyoConsent()]);
      if ($('#consent_marketing').is(':checked')) {
        _learnq.push(['identify', klaviyoEmailMarketing()]);
      }
    };

    _learnq.identify({
      '$email': $('input#k_id_email').val()
    }, undefined, undefined, onIdentifyCompleteCallback);
    
  });
});

if (document.querySelector('.page-corporate-form')) {
  KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
    $method_type: 'Corporate Form',
    $consent_version: 'Embed default text'
  }
  });
} else if (document.querySelector('.page-reseller-form')) {
  KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
    $method_type: 'Reseller Form',
    $consent_version: 'Embed default text'
  }
  });
}